<template>
  <div class="c-product-overview__customize-label">
    <tippy
      placement="left"
      theme="wilasimple"
      animation="fade"
      arrow="true"
      allow-html="true"
      interactive="true"
      max-width="440px"
    >
      <template #trigger>
        <a :href="link" class="c-product-overview__customize-label--link">
          <i class="far fa-edit"></i>
        </a>
      </template>

      <div class="tooltip__body">
        <span>{{ getProductOverviewTranslations['ProductsOverview.Customizable'] }}</span>
      </div>
    </tippy>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    link: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('translations', ['getProductOverviewTranslations'])
  }
};
</script>

<style lang="scss">
@import '@/css/src/utilities/_variables';
@import '@/css/src/utilities/_mixins';
@import '@/css/src/utilities/_functions';
@import '~bootstrap/scss/mixins';

.c-product-overview {
  &__customize-label {
    position: absolute;
    top: 15px;
    right: 15px;

    &--link {
      @include default-link($body-color);

      background-color: $grey-200;
      box-shadow: 0 3px 5px rgba($black, 0.08);
      border-radius: 100%;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.tippy-tooltip.wilasimple-theme > .tippy-arrow {
  border-left-color: $grey-200;
}

.tippy-tooltip.wilasimple-theme {
  background-color: $grey-200;
  color: $body-color;
  padding: 8px;
  box-shadow: none;
  border-radius: 2px;
  display: flex;

  .tippy {
    &-content {
      padding: 0;
    }
  }

  .tooltip {
    &__body {
      text-align: left;
      display: flex;
      gap: 20px;

      &--content {
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        align-items: flex-start;
      }
    }
  }
}
</style>
